var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 20H15.6C15.3 20 15 19.7 15 19.4V0.600006C15 0.300006 15.3 0 15.6 0H18.4C18.7 0 19 0.300006 19 0.600006V19.4C19 19.7 18.7 20 18.4 20ZM18 1H16V19H18V1ZM13.4 20H10.7C10.4 20 10.1 19.7 10.1 19.4V10.6C10.1 10.3 10.4 10 10.7 10H13.4C13.7 10 14 10.3 14 10.6V19.4C14 19.7 13.7 20 13.4 20ZM13 11H11V19H13V11ZM8.4 20H5.7C5.4 20 5.1 19.7 5.1 19.4V6.70001C5.1 6.40001 5.4 6.10001 5.7 6.10001H8.4C8.7 6.10001 9 6.40001 9 6.70001V19.4C9 19.7 8.7 20 8.4 20ZM8 7H6V19H8V7ZM3.3 20H0.6C0.3 20 0 19.7 0 19.4V14.6C0 14.3 0.3 14 0.6 14H3.3C3.6 14 3.9 14.3 3.9 14.6V19.4C3.9 19.7 3.6 20 3.3 20ZM3 15H1V19H3V15Z",
    fill: "#37474F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.858c79d0ca844071567b3b64f8e92929.svg";
export { ForwardRef as ReactComponent };